import CloseIcon from "@material-ui/icons/Close";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import services from "../../../services";
import { Blogs, Datedropdown, trigger } from "../../Sections/Blog/blog";
import Description from "../description/description";
import Footer from "../footer/footer";
import Functions from "../functions/functions";
import CalculatorData from "./../../Sections/CalculatorsSection/CalculatorData";
import Intermediate from "./Intermediate";
import "./main.css";
import Mobileversion from "./mobileverison";
import ServiceForms from "./ServiceForms";
Modal.setAppElement("#root");

let blogvisible;

function Main(props) {
  const [desc, setDesc] = useState("");
  const [ModalisOpen, setIsOpen] = useState(false);
  const [showform, setshowform] = useState(false);
  useEffect(() => {
    if (!window.sessionStorage.getItem("visited")) {
      setTimeout(() => {
        setIsOpen(true);
        sessionStorage.setItem("visited", true);
      }, 5000);
    } else {
    }
    describe("");
    let id = parseInt(props.service.id);
    if (props.serv1[id - 1].functions.length === 0) {
      console.log("");
    } else {
      describe(props.serv1[id - 1].functions[0]?.description);
    }
  }, [props.services.id]);

  function describe(para) {
    setDesc(para);
  }

  blogvisible = (c) => {
    if (c === "open") {
      document.getElementById("blgcontid").classList.remove("d-none");
      document.getElementById("mblockid").classList.add("d-none");
      document.getElementById("mob_container").classList.add("d-none");
      trigger();
    } else {
      document.getElementById("mblockid").classList.remove("d-none");
      document.getElementById("blgcontid").classList.add("d-none");
      document.getElementById("mob_container").classList.remove("d-none");
    }
  };

  const [calculatorOpen, setCalculatorOpen] = useState(false);
  const [videosOpen, setVideosOpen] = useState(false);
  const [formsOpen, setFormsOpen] = useState(false);
  const calculatorOpenHandler = () => {
    setCalculatorOpen(true);
  };
  const calculatorCloseHandler = () => {
    setCalculatorOpen(false);
  };
  const videosOpenHandler = () => {
    setVideosOpen(true);
  };
  const videosCloseHandler = () => {
    setVideosOpen(false);
  };
  const formsOpenHandler = () => {
    setFormsOpen(true);
  };
  const formsCloseHandler = () => {
    setFormsOpen(false);
  };
  return (
    <>
      <Modal
        isOpen={ModalisOpen}
        onRequestClose={() => setIsOpen(false)}
        contentLabel="My dialog"
        className={`${
          showform ? "modalbackstyling2" : "modalstyling"
        }  modalparent`}
        style={{
          overlay: { backgroundColor: "rgba(0,0,0,0.5)", zIndex: "99" },
        }}
      >
        {!showform ? (
          <>
            <div className="heading">Get in touch</div>
            <div className="desc">Pro Bono</div>
            <div
              className="click"
              onClick={() => {
                setshowform(true);
              }}
            >
              Click Here
            </div>
          </>
        ) : (
          <form className="formstyle">
            <label className="labels">Name*:</label>
            <input type="text" className="fields" required></input>
            <label className="labels">Phone*:</label>
            <input type="text" className="fields" required></input>
            <label className="labels">Email:</label>
            <input type="email" className="fields"></input>
            <label className="labels">Select Service:</label>
            <select defaultValue=" " names="services" className="fields2">
              <option style={{ display: "none" }} className="listitems">
                {" "}
              </option>
              {services.map((val) => {
                return <option className="listitems">{val.title}</option>;
              })}
              <option className="listitems">Other</option>
            </select>
            <label className="labels">Message:</label>

            <textarea className="textareas" rows="3" columns="65"></textarea>
            <div className="button">Submit </div>
          </form>
        )}
      </Modal>
      {!calculatorOpen && !formsOpen && (
        <div
          id="mblockid"
          onClick={(event) => {
            event.stopPropagation();
          }}
          className={`main-block`}
        >
          <h2>
            {props.services.title} <span>{props.services.id}/12</span>
          </h2>
          <div className={`row-con`}>
            <div className="row1">
              <div className={`content`}>
                <div className="info">
                  <div className="halfArrow">
                    <img src="../halfarrow.png" alt="half Arrow" />
                  </div>
                  <div className="details">{props.service.content}</div>
                </div>
                <Functions
                  functions={props.service.functions}
                  describe={describe}
                  onClick={videosCloseHandler}
                />
                <div className="mobile-image"></div>
                <div className="mx-auto my-0 w-100">
                  <Description videosOpen={videosOpen} description={desc} />
                </div>
                <Footer
                  onCalculatorOpen={calculatorOpenHandler}
                  onCalculatorClose={calculatorCloseHandler}
                  onVideosOpen={videosOpenHandler}
                  onVideosClose={videosCloseHandler}
                  onFormsOpen={formsOpenHandler}
                  onFormsClose={formsCloseHandler}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {!calculatorOpen && !formsOpen && (
        <div id="blgcontid" className={`blogdiv d-none`}>
          <div className={`d-flex flex-row withfilter`}>
            <CloseIcon onClick={() => blogvisible("close")} />
            <h2>
              {props.services.title} <span>{props.services.id}/12</span>
            </h2>
            <Datedropdown isService={true} />
          </div>
          <Blogs isService={true} />
        </div>
      )}
      {calculatorOpen && (
        <Intermediate
          onOpenCalculator={calculatorOpenHandler}
          onCloseCalculator={calculatorCloseHandler}
          calculators={CalculatorData.filter(
            (calc) => calc.category === props.category
          )}
          serviceTitle={props.services.title}
          serviceId={props.services.id}
        />
      )}
      {formsOpen && (
        <ServiceForms Mobileversion={false} onCloseForms={formsCloseHandler} />
      )}
      {/* Pass the calcultors filtered by category chosen in nav */}
      <Mobileversion
        blogvisible={blogvisible}
        setdesc={describe}
        description={desc}
        services={props.services}
        serv1={props.serv1}
        mainContent={props.mainContent}
        service={props.service}
      />
    </>
  );
}

export { blogvisible };
export default Main;
